import React from 'react'
import { Link } from 'react-router-dom';


const Weather = () => {
    return (
        <>
            

            <section className="bg-body section-space-less30">
                <div className="container">
                    <div className="ne-isotope">
                        <div className="row">
                            <div className="col-12">
                                <div className="topic-border color-azure-radiance mb-30">
                                    <div className="topic-box-lg color-azure-radiance">राशिफल और पंचांग & मौसम</div>
                                </div>
                            </div>
                        </div>
                        <div className="featuredContainer">
                            <div className="row tenies">

                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div className="row keep-items-4-md">
                                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
                                            <div className='container'>
                                                <div id="text-11" className="container-wrapper widget widget_text">

                                                    <div className="textwidget">
                                                        <div style={{ height: 300 }}>
                                                            <iframe src="https://piushtrivedi.neocities.org/hindi_astrology_google_gadget_part_1_updated_html2.html" width="100%" height="100%" frameBorder={0} scrolling="no" />
                                                        </div>
                                                    </div>
                                                    <div className="clearfix" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
                                            <aside className="" aria-label="Primary Sidebar">
                                                <div className="theiaStickySidebar" >
                                                    <div id="recent-posts-3" className="container-wrapper widget widget_recent_entries">

                                                        <div className="clearfix" />
                                                    </div>
                                                    <div id="text-12" className="container-wrapper widget widget_text">

                                                        <div className="textwidget" style={{}}>
                                                            <div style={{ height: 300, width: '' }}>
                                                                <iframe src="https://www.igoogleportal.com/shindig/gadgets/ifr?url=http://hosting.gmodules.com/ig/gadgets/file/109787730588197067267/hindi_panchang.xml&lang=en&country=ALL" width="100%" height="100%" frameBorder={0} scrolling="no" />
                                                            </div>
                                                        </div>
                                                        <div className="clearfix" />
                                                    </div>
                                                </div>
                                            </aside>
                                        </div>
                                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
                                            <div className="container-wrapper widget widget_text">
                                                <div className="textwidget"><p>
                                                    <iframe src="https://api.wo-cloud.com/content/widget/?geoObjectKey=16143051&language=en&region=IN&timeFormat=HH:mm&windUnit=kmh&systemOfMeasurement=metric&temperatureUnit=celsius" scrolling="no" width={290} height={318} frameBorder={0} style={{ border: '1px solid #00537F', borderRadius: 8 }} />
                                                    <br />
                                                </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default Weather